import { Component, Input, OnInit, inject, input } from '@angular/core';
import {
    EditableItemSectionComponent,
    GrowInAnimation,
    OpacityInAnimation,
    OpacityOutAnimation,
    ContextFrameComponent,
    ActionListItemComponent,
    ActionListItemActionComponent,
    ArrayCleanPipe,
} from '@exl-ng/mulo-common';
import {
    UntypedFormBuilder,
    Validators,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { EntityLocation } from '../../shared/interfaces/entity-location';
import { EntityService } from '../../core/entity.service';
import { take } from 'rxjs';
import { ErrorsTranslatePipe } from '../../shared/pipes/errors-translate.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatList, MatListItemIcon } from '@angular/material/list';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { SlicePipe } from '@angular/common';

@Component({
    selector: 'esp-entity-locations',
    templateUrl: './entity-locations.component.html',
    styleUrls: ['./entity-locations.component.scss'],
    animations: [OpacityInAnimation, OpacityOutAnimation, GrowInAnimation],
    imports: [
        ContextFrameComponent,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatSelect,
        MatOption,
        MatButton,
        MatList,
        ActionListItemComponent,
        MatIcon,
        MatListItemIcon,
        ActionListItemActionComponent,
        SlicePipe,
        ArrayCleanPipe,
        TranslateModule,
        ErrorsTranslatePipe,
    ],
})
export class EntityLocationsComponent
    extends EditableItemSectionComponent<EntityLocation>
    implements OnInit
{
    private fb = inject(UntypedFormBuilder);

    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() entityId: string;
    readonly entityService = input<EntityService>(undefined);
    readonly countries = input([]);

    addressMaxLength = 1024;

    constructor() {
        super();
        const fb = this.fb;

        this.form = fb.group({
            address1: ['', [Validators.maxLength(this.addressMaxLength)]],
            address2: ['', [Validators.maxLength(this.addressMaxLength)]],
            city: ['', [Validators.maxLength(50)]],
            state: ['', [Validators.maxLength(50)]],
            displayCountry: [''],
            countryCode: [''],
            id: [''],
            parentId: [this.entityId],
        });
        this.formInitConfig = {
            parentId: this.entityId,
        };
    }

    ngOnInit(): void {
        this.entityId = this.entityId || this.entityService()?.entityId;
        this.formInitConfig.parentId = this.entityId;
    }

    handleSubmit() {
        this.submitInProgress.set(true);

        this.entityService()
            .updateSectionItem('locations', this.form.value)
            .pipe(take(1))
            .subscribe(
                (item) => {
                    const id = this.form?.get('id').value;
                    if (id === '' || id === null) {
                        super.addItem(item);
                    } else {
                        super.editItem(item, this.itemInEdit());
                    }
                },
                (error) => {
                    console.error(error);
                    this.submitInProgress.set(false);
                },
            );
    }

    removeItem(index) {
        const item = this.items()[index];

        this.entityService()
            .deleteSectionItem(
                'locations',
                item.id,
                () => super.removeItem(index),
                this.ariaLabel(),
                item.address1 ||
                    item.address2 ||
                    item.city ||
                    item.state ||
                    item.displayCountry,
            )
            .subscribe();
    }
}
